import toast from 'react-hot-toast';
import secure_axios from '../secure_axios';

import { downloadWithFileName, trataErroBlob } from '../../util/download';

async function geraRelatorio(tipoRelatorio, parametrosDaExtracao) {

    try {
        const response = await toast.promise(
            secure_axios.get(
                `report/${tipoRelatorio.backend_url_rota_sufixo}`,
                {
                    params: parametrosDaExtracao,
                    responseType: 'blob'
                }
            ),
            { loading: 'Extraindo relatório...' }
        )
        downloadWithFileName(response);
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

export {
    geraRelatorio
}
